import Modal from "components/Modal";
import ContactMenu from "./ContactMenu";
import * as S from "./PldErrorModal.style";

const mensagens = {
  parcial: (
    <S.Message variant="body-01-sm">
      Não conseguimos concluir a sua compra por aqui. Mas{" "}
      <strong>
        você ainda pode dar sequência com um dos nossos especialistas
      </strong>{" "}
      pela nossa central de relacionamento, por meio da verificação de alguns
      dados. :)
    </S.Message>
  ),
  total: (
    <S.Message variant="body-01-sm">
      <strong>Informe ao cliente</strong>: Por causa de critérios de aceitação
      da empresa, não é possível seguir adiante com a contratação desse produto
      ou serviço. Esses critérios levam em conta vários fatores e nenhum deles é
      pessoal. A prática de avaliação é legítima no mercado segurador
      brasileiro. <br />
      <br />
      Também não há qualquer regulamento da SUSEP ou na legislação vigente que
      determine a contratação de algum produto ou serviço, conforme as suas
      condições gerais.
    </S.Message>
  ),
};

const PldErrorModal = ({ onClose, bloqueio }) => {
  return (
    <Modal
      open={!!bloqueio}
      onClose={onClose}
      title="Ops, não é possível continuar com a compra"
      description={mensagens[bloqueio]}
    >
      {bloqueio === "parcial" && (
        <ContactMenu messagePhone="Das 8h às 21h, de segunda a sexta, exceto em feriados nacionais." />
      )}
    </Modal>
  );
};

export default PldErrorModal;
